import {ga4} from './ga4'

/**
 * Signals that the customer has identified themselves.
 *
 * The email address is deliberately NOT forwarded: GA4 prohibits sending personally
 * identifiable information to the dataLayer, so this records only that contact
 * details were captured. Sentry previously attached the address to the session -
 * that association no longer exists.
 */
const setTrackingUser = (email: string) => {
  try {
    ga4({
      event: 'set_tracking_user',
      tracking: {
        identified: Boolean(email),
      },
    })
  } catch (error) {
    console.error(error)
  }
}

export default setTrackingUser
